export default __webpack_public_path__ + "static/media/green.c212474f.gif";